import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import type { MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';
import { MAT_LEGACY_SNACK_BAR_DEFAULT_OPTIONS as MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/legacy-snack-bar';

const materialModules = [
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatMenuModule
];

const snackbarDefaultOptions: MatSnackBarConfig = {
    horizontalPosition: 'right',
    verticalPosition: 'bottom'
};

@NgModule({
    imports: materialModules,
    exports: materialModules,
    providers: [
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: snackbarDefaultOptions
        },
    ]
})
export class AppMaterialModule {
}
